module.exports = __webpack_public_path__ + "static/img/testresulttit.500ba33.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/testresulttit.png?v=1
// module id = duQA
// module chunks = 1